/* ------------------------------------ DFD -------------------------------------------- */

/*-----------------------------------SEARCH-DEMANDE-----------------------------------*/
export const SEARCH_DEMANDE = "SEARCH_DEMANDE";
export const SEARCH_DEMANDE_SUCCESS = "SEARCH_DEMANDE_SUCCESS";
export const SEARCH_DEMANDE_FAIL = "SEARCH_DEMANDE_FAIL";

/*-----------------------------------AUTHENTICATE-USER-----------------------------------*/
export const SEARCH_ALL_DEMANDES = "SEARCH_ALL_DEMANDES";
export const SEARCH_ALL_DEMANDES_SUCCESS = "SEARCH_ALL_DEMANDES_SUCCESS";
export const SEARCH_ALL_DEMANDES_FAILURE = "SEARCH_ALL_DEMANDES_FAILURE";

/*-----------------------------------REGISTER-MFA-USER-----------------------------------*/
export const REGISTER_MFA = "REGISTER_MFA";
export const REGISTER_MFA_SUCCESS = "REGISTER_MFA_SUCCESS";
export const REGISTER_MFA_FAILURE = "REGISTER_MFA_FAILURE";

/*-----------------------------------SEND-OTP-MAIL-----------------------------------*/
export const SEND_OTP_MAIL = "SEND_OTP_MAIL";
export const SEND_OTP_MAIL_SUCCESS = "SEND_OTP_MAIL_SUCCESS";
export const SEND_OTP_MAIL_FAILURE = "SEND_OTP_MAIL_FAILURE";

/*-----------------------------------AUTHENTICATE-USER-----------------------------------*/
export const AUTHENTICATE_USER = "AUTHENTICATE_USER";
export const AUTHENTICATE_USER_SUCCESS = "AUTHENTICATE_USER_SUCCESS";
export const AUTHENTICATE_USER_FAILURE = "AUTHENTICATE_USER_FAILURE";
export const SET_IS_AUTHENTICATED = "SET_IS_AUTHENTICATED";
/*----------------------------------POST-CHANGE-PASSWORD---------------------------------*/
export const POST_CHANGE_PASSWORD = "POST_CHANGE_PASSWORD";
export const POST_CHANGE_PASSWORD_SUCCESS = "POST_CHANGE_PASSWORD_SUCCESS";
export const POST_CHANGE_PASSWORD_FAILURE = "POST_CHANGE_PASSWORD_FAILURE";

/*----------------------------------CLEAR-CHANGE-PASSWORD---------------------------------*/
export const CLEAR_CHANGE_PASSWORD = "CLEAR_CHANGE_PASSWORD";

/*-----------------------------------RESET-STATE-----------------------------------*/
export const RESET_ERROR = "RESET_ERROR";

/*-----------------------------------FETCH-CATEGORIES-----------------------------------*/
export const FETCH_CATEGORIES = "FETCH_CATEGORIES";
export const FETCH_CATEGORIES_SUCCESS = "FETCH_CATEGORIES_SUCCESS";
export const FETCH_CATEGORIES_FAILURE = "FETCH_CATEGORIES_FAILURE";

/*-----------------------------------FETCH-ETAT-----------------------------------*/
export const FETCH_ETATS = "FETCH_ETATS";
export const FETCH_ETATS_SUCCESS = "FETCH_ETATS_SUCCESS";
export const FETCH_ETATS_FAILURE = "FETCH_ETATS_FAILURE";

/*-----------------------------------FETCH-ETAT-----------------------------------*/
export const FETCH_PAYS_ORIGINE = "FETCH_PAYS_ORIGINE";
export const FETCH_PAYS_ORIGINE_SUCCESS = "FETCH_PAYS_ORIGINE_SUCCESS";
export const FETCH_PAYS_ORIGINE_FAILURE = "FETCH_PAYS_ORIGINE_FAILURE";

/*-----------------------------------FETCH-CATEGORIES-----------------------------------*/
export const FETCH_GROUPES_CONTINGENT = " FETCH_GROUPES_CONTINGENT";
export const FETCH_GROUPES_CONTINGENT_SUCCESS =
  " FETCH_GROUPES_CONTINGENT_SUCCESS";
export const FETCH_GROUPES_CONTINGENT_FAILURE =
  " FETCH_GROUPES_CONTINGENT_FAILURE";

/*-----------------------------------FETCH-NOMENCLATURES-----------------------------------*/
export const FETCH_NOMENCLATURES = "FETCH_NOMENCLATURES";
export const FETCH_NOMENCLATURES_SUCCESS = "FETCH_NOMENCLATURES_SUCCESS";
export const FETCH_NOMENCLATURES_FAILURE = "FETCH_NOMENCLATURES_FAILURE";

/*-----------------------------------FETCH-NOMENCLATURES-GROUP------------------------------------*/
export const FETCH_NOMENCLATURES_GROUP = "FETCH_NOMENCLATURES_GROUP";
export const FETCH_NOMENCLATURES_GROUP_SUCCESS =
  "FETCH_NOMENCLATURES_GROUP_SUCCESS";
export const FETCH_NOMENCLATURES_GROUP_FAILURE =
  "FETCH_NOMENCLATURES_GROUP_FAILURE";

/*-----------------------------------FETCH-IMPORTATEURS-----------------------------------*/
export const FETCH_IMPORTATEURS = "FETCH_IMPORTATEURS";
export const FETCH_IMPORTATEURS_SUCCESS = "FETCH_IMPORTATEURS_SUCCESS";
export const FETCH_IMPORTATEURS_FAILURE = "FETCH_IMPORTATEURS_FAILURE";

/*-----------------------------------RESET-STATE-----------------------------------*/
export const RESET_STATE = "RESET_STATE";

/*----------------------------------------FETCH-DFD----------------------------------------*/
export const FETCH_DFD = "FETCH_DFD";
export const FETCH_DFD_SUCCESS = "FETCH_DFD_SUCCESS";
export const FETCH_DFD_FAILURE = "FETCH_DFD_FAILURE";

/*----------------------------------------FETCH-HISTORIQUE-DFD----------------------------------------*/
export const FETCH_HISTORIQUE_DFD = "FETCH_HISTORIQUE_DFD";
export const FETCH_HISTORIQUE_DFD_SUCCESS = "FETCH_HISTORIQUE_DFD_SUCCESS";
export const FETCH_HISTORIQUE_DFD_FAILURE = "FETCH_HISTORIQUE_DFD_FAILURE";

/*----------------------------------------CLEAR-HISTORIQUE-DFD----------------------------------------*/
export const CLEAR_HISTORIQUE_DFD = "CLEAR_HISTORIQUE_DFD";

/*------------------------------------FETCH-DFD-DECISIONS------------------------------------*/
export const FETCH_DFD_DECISIONS = "FETCH_DFD_DECISIONS";
export const FETCH_DFD_DECISIONS_SUCCESS = "FETCH_DFD_DECISIONS_SUCCESS";
export const FETCH_DFD_DECISIONS_FAILURE = "FETCH_DFD_DECISIONS_FAILURE";

/*------------------------------------FETCH-DFD-DECISIONS------------------------------------*/
export const FETCH_DFD_DOCUMENTS = "FETCH_DFD_DOCUMENTS_DOCUMENTS";
export const FETCH_DFD_DOCUMENTS_SUCCESS = "FETCH_DFD_DOCUMENTS_SUCCESS";
export const FETCH_DFD_DOCUMENTS_FAILURE = "FETCH_DFD_DOCUMENTS_FAILURE";

/*------------------------------------FETCH-DFD-MARCHANDISES------------------------------------*/
export const FETCH_DFD_MARCHANDISES = "FETCH_DFD_MARCHANDISES";
export const FETCH_DFD_MARCHANDISES_SUCCESS = "FETCH_DFD_MARCHANDISES_SUCCESS";
export const FETCH_DFD_MARCHANDISES_FAILURE = "FETCH_DFD_MARCHANDISES_FAILURE";

/*-------------------------------------DOWNLOAD-DEMAND-------------------------------------*/
export const DOWNLOAD_DEMAND = "DOWNLOAD_DEMAND";
export const DOWNLOAD_DEMAND_SUCCESS = "DOWNLOAD_DEMAND_SUCCESS";
export const DOWNLOAD_DEMAND_FAILURE = "DOWNLOAD_DEMAND_FAILURE";

/*----------------------------------DOWNLOAD-DEMAND-DOCUMENT----------------------------------*/
export const DOWNLOAD_DEMAND_DOCUMENT = "DOWNLOAD_DEMAND_DOCUMENT";
export const DOWNLOAD_DEMAND_DOCUMENT_SUCCESS =
  "DOWNLOAD_DEMAND_DOCUMENT_SUCCESS";
export const DOWNLOAD_DEMAND_DOCUMENT_FAILURE =
  "DOWNLOAD_DEMAND_DOCUMENT_FAILURE";

/*----------------------------------FETCH-TYPE-DECISION----------------------------------*/
export const FETCH_TYPE_DECISION = "FETCH_TYPE_DECISION";
export const FETCH_TYPE_DECISION_SUCCESS = "FETCH_TYPE_DECISION_SUCCESS";
export const FETCH_TYPE_DECISION_FAILURE = "FETCH_TYPE_DECISION_FAILURE";

/*----------------------------------FETCH-UNIT-COMP----------------------------------*/
export const FETCH_UNIT_COMP = "FETCH_UNIT_COMP";
export const FETCH_UNIT_COMP_SUCCESS = "FETCH_UNIT_COMP_SUCCESS";
export const FETCH_UNIT_COMP_FAILURE = "FETCH_UNIT_COMP_FAILURE";

/*----------------------------------FETCH-UNIT-DOUNIERE----------------------------------*/
export const FETCH_TYPE_DOUNIERE = "FETCH_TYPE_DOUNIERE";
export const FETCH_TYPE_DOUNIERE_SUCCESS = "FETCH_TYPE_DOUNIERE_SUCCESS";
export const FETCH_TYPE_DOUNIERE_FAILURE = "FETCH_TYPE_DOUNIERE_FAILURE";

/*----------------------------------FETCH-DEPARTMENTS----------------------------------*/
export const FETCH_DEPARTMENTS = "FETCH_DEPARTMENTS";
export const FETCH_DEPARTMENTS_SUCCESS = "FETCH_DEPARTMENTS_SUCCESS";
export const FETCH_DEPARTMENTS_FAILURE = "FETCH_DEPARTMENTS_FAILURE";

/*----------------------------------DECISION-MCE-DFD----------------------------------*/
export const DECISION_MCE_DFD = "DECISION_MCE_DFD";
export const DECISION_MCE_DFD_SUCCESS = "DECISION_MCE_DFD_SUCCESS";
export const DECISION_MCE_DFD_FAILURE = "DECISION_MCE_DFD_FAILURE";

/*----------------------------------DECISION-DEP-DFD----------------------------------*/
export const DECISION_DEP_DFD = "DECISION_DEP_DFD";
export const DECISION_DEP_DFD_SUCCESS = "DECISION_DEP_DFD_SUCCESS";
export const DECISION_DEP_DFD_FAILURE = "DECISION_DEP_DFD_FAILURE";

/*----------------------------------TRANSFER-DFD----------------------------------*/
export const TRANSFER_DFD = "TRANSFER_DFD";
export const TRANSFER_DFD_SUCCESS = "TRANSFER_DFD_SUCCESS";
export const TRANSFER_DFD_FAILURE = "TRANSFER_DFD_FAILURE";

/*----------------------------------SELECTED-DEPARTMENT----------------------------------*/
export const SELECTED_DEPARTMENT = "SELECTED_DEPARTMENT";
export const SELECTED_DEPARTMENT_SUCCESS = "SELECTED_DEPARTMENT_SUCCESS";
export const SELECTED_DEPARTMENT_FAILURE = "SELECTED_DEPARTMENT_FAILURE";

/*-----------------------------------SET-DECISION-MODE-----------------------------------*/
export const SET_DECISION_MODE = "SET_DECISION_MODE";

/*----------------------------------GET-FIXED-DFD-DECISION---------------------------------*/
export const GET_FIXED_DFD_DECISION = "GET_FIXED_DFD_DECISION";
export const GET_FIXED_DFD_DECISION_SUCCESS = "GET_FIXED_DFD_DECISION_SUCCESS";
export const GET_FIXED_DFD_DECISION_FAILURE = "GET_FIXED_DFD_DECISION_FAILURE";

/*-----------------------------------CLEAR-DEMANDE-DETIALS-----------------------------------*/
export const CLEAR_DEMANDE_DETIALS = "CLEAR_DEMANDE_DETIALS";

/*-----------------------------------UPDATE-SEARCH-FORM-----------------------------------*/
export const UPDATE_SEARCH_FORM = "UPDATE_DEMANDE_FORM";

/*-----------------------------------CLEAR-SEARCH-FORM-----------------------------------*/
export const CLEAR_SEARCH_FORM = "CLEAR_DEMANDE_FORM";

/*-----------------------------------SET-DFD-COLUMNS-STATE-----------------------------------*/
export const SET_DFD_COLUMNS_DENSITY_STATE = "SET_DFD_COLUMNS_DENSITY_STATE";

/*-----------------------------------GET-DFD-COLUMNS-STATE-----------------------------------*/
export const GET_DFD_COLUMNS_DENSITY_STATE = "GET_DFD_COLUMNS_DENSITY_STATE";
export const GET_DFD_COLUMNS_DENSITY_STATE_SUCCESS =
  "GET_DFD_COLUMNS_DENSITY_STATE_SUCCESS";
export const GET_DFD_COLUMNS_DENSITY_STATE_FAILURE =
  "GET_DFD_COLUMNS_DENSITY_STATE_FAILURE";

/*-----------------------------------UPDATE-DFD-DATE-FIN---------------------------------*/
export const UPDATE_DFD_DATE_FIN_VALIDITE = "UPDATE_DFD_DATE_FIN_VALIDITE";
export const UPDATE_DFD_DATE_FIN_VALIDITE_SUCCESS =
  "UPDATE_DFD_DATE_FIN_VALIDITE_SUCCESS";
export const UPDATE_DFD_DATE_FIN_VALIDITE_FAILURE =
  "UPDATE_DFD_DATE_FIN_VALIDITE_FAILURE";

/**************************************************************************************************************/

/* ------------------------------------ LE -------------------------------------------- */

/*-----------------------------------SET-LE-COLUMNS-STATE-----------------------------------*/
export const SET_LE_COLUMNS_DENSITY_STATE = "SET_LE_COLUMNS_DENSITY_STATE";

/*-----------------------------------GET-LE-COLUMNS-STATE-----------------------------------*/
export const GET_LE_COLUMNS_DENSITY_STATE = "GET_LE_COLUMNS_DENSITY_STATE";
export const GET_LE_COLUMNS_DENSITY_STATE_SUCCESS =
  "GET_LE_COLUMNS_DENSITY_STATE_SUCCESS";
export const GET_LE_COLUMNS_DENSITY_STATE_FAILURE =
  "GET_LE_COLUMNS_DENSITY_STATE_FAILURE";

/*-----------------------------------SEARCH-LICENCE-----------------------------------*/
export const SEARCH_LICENCE = "SEARCH_LICENCE";
export const SEARCH_LICENCE_SUCCESS = "SEARCH_LICENCE_SUCCESS";
export const SEARCH_LICENCE_FAIL = "SEARCH_LICENCE_FAIL";

/*-----------------------------------FETCH-ALL-LICENCES-----------------------------------*/
export const SEARCH_ALL_LICENCES = "SEARCH_ALL_LICENCES";
export const SEARCH_ALL_LICENCES_SUCCESS = "SEARCH_ALL_LICENCES_SUCCESS";
export const SEARCH_ALL_LICENCES_FAILURE = "SEARCH_ALL_LICENCES_FAILURE";

/*-----------------------------------UPDATE-LE-SEARCH-FORM-----------------------------------*/
export const UPDATE_LE_SEARCH_FORM = "UPDATE_LE_SEARCH_FORM";

/*-----------------------------------CLEAR-LE-SEARCH-FORM-----------------------------------*/
export const CLEAR_LE_SEARCH_FORM = "CLEAR_LE_SEARCH_FORM";

/*----------------------------------------FETCH-LE----------------------------------------*/
export const FETCH_LE = "FETCH_LE";
export const FETCH_LE_SUCCESS = "FETCH_LE_SUCCESS";
export const FETCH_LE_FAILURE = "FETCH_LE_FAILURE";

/*-----------------------------------SET-LE-DECISION-MODE-----------------------------------*/
export const SET_LE_DECISION_MODE = "SET_LE_DECISION_MODE";

/*----------------------------------DOWNLOAD-FACTURE-DOCUMENT----------------------------------*/
export const DOWNLOAD_FACTURE_DOCUMENT = "DOWNLOAD_FACTURE_DOCUMENT";
export const DOWNLOAD_FACTURE_DOCUMENT_SUCCESS =
  "DOWNLOAD_FACTURE_DOCUMENT_SUCCESS";
export const DOWNLOAD_FACTURE_DOCUMENT_FAILURE =
  "DOWNLOAD_FACTURE_DOCUMENT_FAILURE";

/*----------------------------------DOWNLOAD-LE-DOCUMENT----------------------------------*/
export const DOWNLOAD_LE_DOCUMENT = "DOWNLOAD_LE_DOCUMENT";
export const DOWNLOAD_LE_DOCUMENT_SUCCESS = "DOWNLOAD_LE_DOCUMENT_SUCCESS";
export const DOWNLOAD_LE_DOCUMENT_FAILURE = "DOWNLOAD_LE_DOCUMENT_FAILURE";

/*----------------------------------DOWNLOAD-LE----------------------------------*/
export const DOWNLOAD_LE = "DOWNLOAD_LE";
export const DOWNLOAD_LE_SUCCESS = "DOWNLOAD_LE_SUCCESS";
export const DOWNLOAD_LE_FAILURE = "DOWNLOAD_LE_FAILURE";

/*----------------------------------CLEAR-LE-DETAILS---------------------------------*/
export const CLEAR_LE_DETIALS = "CLEAR_LE_DETIALS";

/*----------------------------------CLEAR-LE-HISTORIQUE---------------------------------*/
export const CLEAR_HISTORIQUE_LE = "CLEAR_HISTORIQUE_LE";

/*----------------------------------------FETCH-HISTORIQUE-DFD----------------------------------------*/
export const FETCH_HISTORIQUE_LE = "FETCH_HISTORIQUE_LE";
export const FETCH_HISTORIQUE_LE_SUCCESS = "FETCH_HISTORIQUE_LE_SUCCESS";
export const FETCH_HISTORIQUE_LE_FAILURE = "FETCH_HISTORIQUE_LE_FAILURE";

/*-----------------------------------FETCH-LE-ETAT-----------------------------------*/
export const FETCH_LE_ETATS = "FETCH_LE_ETATS";
export const FETCH_LE_ETATS_SUCCESS = "FETCH_LE_ETATS_SUCCESS";
export const FETCH_LE_ETATS_FAILURE = "FETCH_LE_ETATS_FAILURE";

/*-----------------------------------FETCH-DEVISE-----------------------------------*/
export const FETCH_DEVISE = "FETCH_DEVISE";
export const FETCH_DEVISE_SUCCESS = "FETCH_DEVISE_SUCCESS";
export const FETCH_DEVISE_FAILURE = "FETCH_DEVISE_FAILURE";

/*----------------------------------FETCH-MODE-PAIEMENT----------------------------------*/
export const FETCH_MODE_PAIEMENT = "FETCH_MODE_PAIEMENT";
export const FETCH_MODE_PAIEMENT_SUCCESS = "FETCH_MODE_PAIEMENT_SUCCESS";
export const FETCH_MODE_PAIEMENT_FAILURE = "FETCH_MODE_PAIEMENT_FAILURE";

/*----------------------------------FETCH-INCOTERM----------------------------------*/
export const FETCH_INCOTERM = "FETCH_INCOTERM";
export const FETCH_INCOTERM_SUCCESS = "FETCH_INCOTERM_SUCCESS";
export const FETCH_INCOTERM_FAILURE = "FETCH_INCOTERM_FAILURE";

/*----------------------------------FETCH-REGIME-DOUANIER----------------------------------*/
export const FETCH_REGIME_DOUANIER = "FETCH_REGIME_DOUANIER";
export const FETCH_REGIME_DOUANIER_SUCCESS = "FETCH_REGIME_DOUANIER_SUCCESS";
export const FETCH_REGIME_DOUANIER_FAILURE = "FETCH_REGIME_DOUANIER_FAILURE";

/*----------------------------------FETCH-BUREAU-DOUANIER----------------------------------*/
export const FETCH_BUREAU_DOUANIER = "FETCH_BUREAU_DOUANIER";
export const FETCH_BUREAU_DOUANIER_SUCCESS = "FETCH_BUREAU_DOUANIER_SUCCESS";
export const FETCH_BUREAU_DOUANIER_FAILURE = "FETCH_BUREAU_DOUANIER_FAILURE";

/*----------------------------------FETCH-EXPORTATEURS----------------------------------*/
export const FETCH_EXPORTATEURS = "FETCH_EXPORTATEURS";
export const FETCH_EXPORTATEURS_SUCCESS = "FETCH_EXPORTATEURS_SUCCESS";
export const FETCH_EXPORTATEURS_FAILURE = "FETCH_EXPORTATEURS_FAILURE";

/*----------------------------------FETCH-DECLARANT----------------------------------*/
export const FETCH_DECLARANT = "FETCH_DECLARANT";
export const FETCH_DECLARANT_SUCCESS = "FETCH_DECLARANT_SUCCESS";
export const FETCH_DECLARANT_FAILURE = "FETCH_DECLARANT_FAILURE";

/*-----------------------------------FETCH-LE-NOMENCLATURES-----------------------------------*/
export const FETCH_LE_NOMENCLATURES = "FETCH_LE_NOMENCLATURES";
export const FETCH_LE_NOMENCLATURES_SUCCESS = "FETCH_LE_NOMENCLATURES_SUCCESS";
export const FETCH_LE_NOMENCLATURES_FAILURE = "FETCH_LE_NOMENCLATURES_FAILURE";

/*-----------------------------------FETCH-TYPE-TI-----------------------------------*/
export const FETCH_TYPE_TI = "FETCH_TYPE_TI";
export const FETCH_TYPE_TI_SUCCESS = "FETCH_TYPE_TI_SUCCESS";
export const FETCH_TYPE_TI_FAILURE = "FETCH_TYPE_TI_FAILURE";

/*-----------------------------------FETCH-TYPE-TE-----------------------------------*/
export const FETCH_TYPE_TE = "FETCH_TYPE_TE";
export const FETCH_TYPE_TE_SUCCESS = "FETCH_TYPE_TE_SUCCESS";
export const FETCH_TYPE_TE_FAILURE = "FETCH_TYPE_TE_FAILURE";

/*----------------------------------FETCH-TYPE-DECISION-LE----------------------------------*/
export const FETCH_TYPE_DECISION_LE = "FETCH_TYPE_DECISION_LE";
export const FETCH_TYPE_DECISION_LE_SUCCESS = "FETCH_TYPE_DECISION_LE_SUCCESS";
export const FETCH_TYPE_DECISION_LE_FAILURE = "FETCH_TYPE_DECISION_LE_FAILURE";

/*----------------------------------FETCH-DEPARTMENTS----------------------------------*/
export const FETCH_DEPARTMENTS_LE = "FETCH_DEPARTMENTS_LE";
export const FETCH_DEPARTMENTS_LE_SUCCESS = "FETCH_DEPARTMENTS_LE_SUCCESS";
export const FETCH_DEPARTMENTS_LE_FAILURE = "FETCH_DEPARTMENTS_LE_FAILURE";

/*----------------------------------TRANSFER-LE----------------------------------*/
export const TRANSFER_LE = "TRANSFER_LE";
export const TRANSFER_LE_SUCCESS = "TRANSFER_LE_SUCCESS";
export const TRANSFER_LE_FAILURE = "TRANSFER_LE_FAILURE";

/*----------------------------------GET-AUTHORITIES----------------------------------*/
export const GET_AUTHORITIES = "GET_AUTHORITIES";
export const GET_AUTHORITIES_SUCCESS = "GET_AUTHORITIES_SUCCESS";
export const GET_AUTHORITIES_FAILURE = "GET_AUTHORITIES_FAILURE";

/*----------------------------------DECISION-MCE-LE----------------------------------*/
export const DECISION_MCE_LE = "DECISION_MCE_LE";
export const DECISION_MCE_LE_SUCCESS = "DECISION_MCE_LE_SUCCESS";
export const DECISION_MCE_LE_FAILURE = "DECISION_MCE_LE_FAILURE";

/*----------------------------------DECISION-DEP-LE----------------------------------*/
export const DECISION_DEP_LE = "DECISION_DEP_LE";
export const DECISION_DEP_LE_SUCCESS = "DECISION_DEP_LE_SUCCESS";
export const DECISION_DEP_LE_FAILURE = "DECISION_DEP_LE_FAILURE";

/*----------------------------------CAN-TAKE-DECISION----------------------------------*/
export const CAN_TAKE_DECISION = "CAN_TAKE_DECISION";
export const CAN_TAKE_DECISION_SUCCESS = "CAN_TAKE_DECISION_SUCCESS";
export const CAN_TAKE_DECISION_FAILURE = "CAN_TAKE_DECISION_FAILURE";

/*-----------------------------------SET-DECISION-VISIBLE-----------------------------------*/
export const SET_DECISION_VISIBLE = "SET_DECISION_VISIBLE";

/*-----------------------------------SET-DECISION-lE-VISIBLE-----------------------------------*/
export const SET_DECISION_LE_VISIBLE = "SET_DECISION_LE_VISIBLE";

/*-----------------------------------UPDATE-LE-DATE-FIN---------------------------------*/
export const UPDATE_LE_DATE_FIN_VALIDITE = "UPDATE_LE_DATE_FIN_VALIDITE";
export const UPDATE_LE_DATE_FIN_VALIDITE_SUCCESS =
  "UPDATE_LE_DATE_FIN_VALIDITE_SUCCESS";
export const UPDATE_LE_DATE_FIN_VALIDITE_FAILURE =
  "UPDATE_LE_DATE_FIN_VALIDITE_FAILURE";

/**************************************************************************************************************/

/* ------------------------------------ TI -------------------------------------------- */

/*-----------------------------------SEARCH-TITRE-----------------------------------*/
export const SEARCH_TITRE = "SEARCH_TITRE";
export const SEARCH_TITRE_SUCCESS = "SEARCH_TITRE_SUCCESS";
export const SEARCH_TITRE_FAILURE = "SEARCH_TITRE_FAILURE";

/*-----------------------------------FETCH-ALL-TITRES-----------------------------------*/
export const SEARCH_ALL_TITRES = "SEARCH_ALL_TITRES";
export const SEARCH_ALL_TITRES_SUCCESS = "SEARCH_ALL_TITRES_SUCCESS";
export const SEARCH_ALL_TITRES_FAILURE = "SEARCH_ALL_TITRES_FAILURE";

/*-----------------------------------UPDATE-TI-SEARCH-FORM-----------------------------------*/
export const UPDATE_TI_SEARCH_FORM = "UPDATE_TI_SEARCH_FORM";

/*-----------------------------------CLEAR-TI-SEARCH-FORM-----------------------------------*/
export const CLEAR_TI_SEARCH_FORM = "CLEAR_TI_SEARCH_FORM";

/*-----------------------------------SET-TI-DECISION-MODE-----------------------------------*/
export const SET_TI_DECISION_MODE = "SET_TI_DECISION_MODE";

/*-----------------------------------FETCH-TI-IMPORTATEURS-----------------------------------*/
export const FETCH_TI_IMPORTATEURS = "FETCH_TI_IMPORTATEURS";
export const FETCH_TI_IMPORTATEURS_SUCCESS = "FETCH_TI_IMPORTATEURS_SUCCESS";
export const FETCH_TI_IMPORTATEURS_FAILURE = "FETCH_TI_IMPORTATEURS_FAILURE";

/*-----------------------------------FETCH-TI-NOMENCLATURES-----------------------------------*/
export const FETCH_TI_NOMENCLATURES = "FETCH_TI_NOMENCLATURES";
export const FETCH_TI_NOMENCLATURES_SUCCESS = "FETCH_TI_NOMENCLATURES_SUCCESS";
export const FETCH_TI_NOMENCLATURES_FAILURE = "FETCH_TI_NOMENCLATURES_FAILURE";

/*-----------------------------------FETCH-TI-GUICHETS-----------------------------------*/
export const FETCH_TI_GUICHETS = "FETCH_TI_GUICHETS";
export const FETCH_TI_GUICHETS_SUCCESS = "FETCH_TI_GUICHETS_SUCCESS";
export const FETCH_TI_GUICHETS_FAILURE = "FETCH_TI_GUICHETS_FAILURE";

/*----------------------------------FETCH-TI-DECLARANT----------------------------------*/
export const FETCH_TI_DECLARANTS = "FETCH_TI_DECLARANT";
export const FETCH_TI_DECLARANTS_SUCCESS = "FETCH_TI_DECLARANT_SUCCESS";
export const FETCH_TI_DECLARANTS_FAILURE = "FETCH_TI_DECLARANT_FAILURE";

/*-----------------------------------FETCH-TI-TYPE-TE-----------------------------------*/
export const FETCH_TI_TYPE_TE = "FETCH_TI_TYPE_TE";
export const FETCH_TI_TYPE_TE_SUCCESS = "FETCH_TI_TYPE_TE_SUCCESS";
export const FETCH_TI_TYPE_TE_FAILURE = "FETCH_TI_TYPE_TE_FAILURE";

/*-----------------------------------FETCH-TI-TYPE-TI-----------------------------------*/
export const FETCH_TI_TYPE_TI = "FETCH_TI_TYPE_TI";
export const FETCH_TI_TYPE_TI_SUCCESS = "FETCH_TI_TYPE_TI_SUCCESS";
export const FETCH_TI_TYPE_TI_FAILURE = "FETCH_TI_TYPE_TI_FAILURE";

/*-----------------------------------FETCH-TI-ETATS-----------------------------------*/
export const FETCH_TI_ETATS = "FETCH_TI_ETATS";
export const FETCH_TI_ETATS_SUCCESS = "FETCH_TI_ETATS_SUCCESS";
export const FETCH_TI_ETATS_FAILURE = "FETCH_TI_ETATS_FAILURE";

/*-----------------------------------FETCH-TI-LOCALITES-----------------------------------*/
export const FETCH_TI_LOCALITES = "FETCH_TI_LOCALITES";
export const FETCH_TI_LOCALITES_SUCCESS = "FETCH_TI_LOCALITES_SUCCESS";
export const FETCH_TI_LOCALITES_FAILURE = "FETCH_TI_LOCALITES_FAILURE";

/*-----------------------------------FETCH-TI-CATEGORIES-----------------------------------*/
export const FETCH_TI_CATEGORIES = "FETCH_TI_CATEGORIES";
export const FETCH_TI_CATEGORIES_SUCCESS = "FETCH_TI_CATEGORIES_SUCCESS";
export const FETCH_TI_CATEGORIES_FAILURE = "FETCH_TI_CATEGORIES_FAILURE";

/*-----------------------------------FETCH-TI-STATUS-MODIF-----------------------------------*/
export const FETCH_TI_STATUS_MODIF = "FETCH_TI_STATUS_MODIF";
export const FETCH_TI_STATUS_MODIF_SUCCESS = "FETCH_TI_STATUS_MODIF_SUCCESS";
export const FETCH_TI_STATUS_MODIF_FAILURE = "FETCH_TI_STATUS_MODIF_FAILURE";

/*-----------------------------------FETCH-TI-TYPE-MESSAGE-----------------------------------*/
export const FETCH_TI_TYPE_MESSAGE = "FETCH_TI_TYPE_MESSAGE";
export const FETCH_TI_TYPE_MESSAGE_SUCCESS = "FETCH_TI_TYPE_MESSAGE_SUCCESS";
export const FETCH_TI_TYPE_MESSAGE_FAILURE = "FETCH_TI_TYPE_MESSAGE_FAILURE";

/*-----------------------------------FETCH-TI-BANQUE-----------------------------------*/
export const FETCH_TI_BANQUE = "FETCH_TI_BANQUE";
export const FETCH_TI_BANQUE_SUCCESS = "FETCH_TI_BANQUE_SUCCESS";
export const FETCH_TI_BANQUE_FAILURE = "FETCH_TI_BANQUE_FAILURE";

/*----------------------------------------FETCH-LE----------------------------------------*/
export const FETCH_TI = "FETCH_TI";
export const FETCH_TI_SUCCESS = "FETCH_TI_SUCCESS";
export const FETCH_TI_FAILURE = "FETCH_TI_FAILURE";

/*-----------------------------------SET-DECISION-lE-VISIBLE-----------------------------------*/
export const SET_DECISION_TI_VISIBLE = "SET_DECISION_TI_VISIBLE";

/*----------------------------------DOWNLOAD-LE----------------------------------*/
export const DOWNLOAD_TI = "DOWNLOAD_TI";
export const DOWNLOAD_TI_SUCCESS = "DOWNLOAD_TI_SUCCESS";
export const DOWNLOAD_TI_FAILURE = "DOWNLOAD_TI_FAILURE";

/*----------------------------------DOWNLOAD-FACTURE-DOCUMENT----------------------------------*/
export const DOWNLOAD_TI_FACTURE_DOCUMENT = "DOWNLOAD_TI_FACTURE_DOCUMENT";
export const DOWNLOAD_TI_FACTURE_DOCUMENT_SUCCESS =
  "DOWNLOAD_TI_FACTURE_DOCUMENT_SUCCESS";
export const DOWNLOAD_TI_FACTURE_DOCUMENT_FAILURE =
  "DOWNLOAD_TI_FACTURE_DOCUMENT_FAILURE";

/*----------------------------------DOWNLOAD-LE-DOCUMENT----------------------------------*/
export const DOWNLOAD_TI_DOCUMENT = "DOWNLOAD_TI_DOCUMENT";
export const DOWNLOAD_TI_DOCUMENT_SUCCESS = "DOWNLOAD_TI_DOCUMENT_SUCCESS";
export const DOWNLOAD_TI_DOCUMENT_FAILURE = "DOWNLOAD_TI_DOCUMENT_FAILURE";

/*-----------------------------------CLEAR-TITRE-DETIALS-----------------------------------*/
export const CLEAR_TITRE_DETIALS = "CLEAR_TITRE_DETIALS";

/*-----------------------------------CLEAR-TITRE-ERROR-----------------------------------*/
export const CLEAR_TITRE_ERROR = "CLEAR_TITRE_ERROR";

/*-----------------------------------FETCH-TI-HISTORIQUE-----------------------------------*/
export const FETCH_HISTORIQUE_TI = "FETCH_HISTORIQUE_TI";
export const FETCH_HISTORIQUE_TI_SUCCESS = "FETCH_HISTORIQUE_TI_SUCCESS";
export const FETCH_HISTORIQUE_TI_FAILURE = "FETCH_HISTORIQUE_TI_FAILURE";

/*-----------------------------------FETCH-TI-HISTORIQUE-----------------------------------*/
export const CLEAR_HISTORIQUE_TI = "CLEAR_HISTORIQUE_TI";

/*----------------------------------FETCH-DEPARTMENTS----------------------------------*/
export const FETCH_DEPARTMENTS_TI = "FETCH_DEPARTMENTS_TI";
export const FETCH_DEPARTMENTS_TI_SUCCESS = "FETCH_DEPARTMENTS_TI_SUCCESS";
export const FETCH_DEPARTMENTS_TI_FAILURE = "FETCH_DEPARTMENTS_TI_FAILURE";

/*----------------------------------TRANSFER-TI----------------------------------*/
export const TRANSFER_TI = "TRANSFER_TI";
export const TRANSFER_TI_SUCCESS = "TRANSFER_TI_SUCCESS";
export const TRANSFER_TI_FAILURE = "TRANSFER_TI_FAILURE";

/*----------------------------------TRANSFER-TI-PROLONG----------------------------------*/
export const TRANSFER_TI_PROLONG = "TRANSFER_TI_PROLONG";
export const TRANSFER_TI_PROLONG_SUCCESS = "TRANSFER_TI_PROLONG_SUCCESS";
export const TRANSFER_TI_PROLONG_FAILURE = "TRANSFER_TI_PROLONG_FAILURE";

/*----------------------------------FETCH-TI-TYPE-DECISION-----------------------------------*/
export const FETCH_TI_TYPE_DECISION_MCE = "FETCH_TI_TYPE_DECISION_MCE";
export const FETCH_TI_TYPE_DECISION_MCE_SUCCESS =
  "FETCH_TI_TYPE_DECISION_MCE_SUCCESS";
export const FETCH_TI_TYPE_DECISION_MCE_FAILURE =
  "FETCH_TI_TYPE_DECISION_MCE_FAILURE";

/*-----------------------------------POST-TI-DECISION-MCE---------------------------------*/
export const POST_TI_DECISION_MCE = "POST_TI_DECISION_MCE";
export const POST_TI_DECISION_MCE_SUCCESS = "POST_TI_DECISION_MCE_SUCCESS";
export const POST_TI_DECISION_MCE_FAILURE = "POST_TI_DECISION_MCE_FAILURE";

/*-----------------------------------POST-TI-DECISION-DEP---------------------------------*/
export const POST_TI_DECISION_DEP = "POST_TI_DECISION_DEP";
export const POST_TI_DECISION_DEP_SUCCESS = "POST_TI_DECISION_DEP_SUCCESS";
export const POST_TI_DECISION_DEP_FAILURE = "POST_TI_DECISION_DEP_FAILURE";

/*-----------------------------------POST-TI-TYPE-DECISION-MCE-PROLONG--------------------------------*/
export const FETCH_TI_TYPE_DECISION_MCE_PROLONG =
  "FETCH_TI_TYPE_DECISION_MCE_PROLONG";
export const FETCH_TI_TYPE_DECISION_MCE_PROLONG_SUCCESS =
  "FETCH_TI_TYPE_DECISION_MCE_PROLONG_SUCCESS";
export const FETCH_TI_TYPE_DECISION_MCE_PROLONG_FAILURE =
  "FETCH_TI_TYPE_DECISION_MCE_PROLONG_FAILURE";

/*-----------------------------------POST-TI-PROLONG-MCE--------------------------------*/
export const POST_TI_PROLONG_MCE = "POST_TI_PROLONG_MCE";
export const POST_TI_PROLONG_MCE_SUCCESS = "POST_TI_PROLONG_MCE_SUCCESS";
export const POST_TI_PROLONG_MCE_FAILURE = "POST_TI_PROLONG_MCE_FAILURE";

/*-----------------------------------POST-TI-PROLONG-DEP---------------------------------*/
export const POST_TI_PROLONG_DEP = "POST_TI_PROLONG_DEP";
export const POST_TI_PROLONG_DEP_SUCCESS = "POST_TI_PROLONG_DEP_SUCCESS";
export const POST_TI_PROLONG_DEP_FAILURE = "POST_TI_PROLONG_DEP_FAILURE";

/*-----------------------------------SET-TI-COLUMNS-STATE-----------------------------------*/
export const SET_TI_COLUMNS_DENSITY_STATE = "SET_TI_COLUMNS_DENSITY_STATE";

/*-----------------------------------GET-TI-COLUMNS-STATE-----------------------------------*/
export const GET_TI_COLUMNS_DENSITY_STATE = "GET_TI_COLUMNS_DENSITY_STATE";
export const GET_TI_COLUMNS_DENSITY_STATE_SUCCESS =
  "GET_TI_COLUMNS_DENSITY_STATE_SUCCESS";
export const GET_TI_COLUMNS_DENSITY_STATE_FAILURE =
  "GET_TI_COLUMNS_DENSITY_STATE_FAILURE";

/*-----------------------------------SET_DRAWER_STATE---------------------------------*/
export const SET_DRAWER_STATE = "SET_DRAWER_STATE";

/*-----------------------------------UPDATE-TI-DATE-FIN---------------------------------*/
export const UPDATE_TI_DATE_FIN_VALIDITE = "UPDATE_TI_DATE_FIN_VALIDITE";
export const UPDATE_TI_DATE_FIN_VALIDITE_SUCCESS =
  "UPDATE_TI_DATE_FIN_VALIDITE_SUCCESS";
export const UPDATE_TI_DATE_FIN_VALIDITE_FAILURE =
  "UPDATE_TI_DATE_FIN_VALIDITE_FAILURE";

/**************************************************************************************************************/

/* ------------------------------------ DASHBOARD -------------------------------------------- */

/*-----------------------------------------DFD-KPI-----------------------------------------*/
export const DFD_KPI = "DFD_KPI";
export const DFD_KPI_SUCCESS = "DFD_KPI_SUCCESS";
export const DFD_KPI_FAILURE = "DFD_KPI_FAILURE";

/*-----------------------------------------LE-KPI-----------------------------------------*/
export const LE_KPI = "LE_KPI";
export const LE_KPI_SUCCESS = "LE_KPI_SUCCESS";
export const LE_KPI_FAILURE = "LE_KPI_FAILURE";

/*-----------------------------------------TI-KPI-----------------------------------------*/
export const TI_KPI = "TI_KPI";
export const TI_KPI_SUCCESS = "TI_KPI_SUCCESS";
export const TI_KPI_FAILURE = "TI_KPI_FAILURE";

/*-----------------------------------SET-LOADINGS-----------------------------------*/
export const SET_DFD_LOADING = "SET_DFD_LOADING";
export const SET_LE_LOADING = "SET_LE_LOADING";
export const SET_TI_LOADING = "SET_TI_LOADING";
